module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--pencil",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 677.34762 182.15429"
    }
  }, [_c('g', [_c('path', {
    staticClass: "body-pencil",
    attrs: {
      "d": "M128.273 0l-3.9 2.77L0 91.078l128.273 91.076 549.075-.006V.008L128.273 0zm20.852 30l498.223.006V152.15l-498.223.007V30zm-25 9.74v102.678l-49.033-34.813-.578-32.64 49.61-35.225z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "line",
    attrs: {
      "d": "M134.482 157.147v25l518.57.008.002-25-518.572-.008z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac8650fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Pencil.vue
// module id = 660
// module chunks = 0